import { useEffect, useState } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/Footer.jsx";
import { useTranslation } from 'react-i18next';
import './style.css';
import i18n from 'i18next';
import { useNavigate } from 'react-router-dom';
import NotificationBell from 'components/NotificationBell';
import { sendToGoodDelivery, getOrderUniqueId } from './deliveryHelper';
import Swal from 'sweetalert2';
const OrdersSans = () => {
    const { t } = useTranslation();
    const [orders, setOrders] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [statusFilter, setStatusFilter] = useState('');
    const [dateFilter, setDateFilter] = useState(''); // values: '7', '15', '30'
    const [searchID, setSearchID] = useState('');
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const currentLang = i18n.language; // e.g. 'fr' or 'ar'
    const navigate = useNavigate();
  const [deliveryLoadingId, setDeliveryLoadingId] = useState(null);
const [isEditModalOpen, setIsEditModalOpen] = useState(false);
const [editingOrder, setEditingOrder] = useState(null);
    // Define the NEW list of statuses for consistency
    const ALL_STATUSES = [
       'confirmé', 'en cours', 'mise en distribution', 'livré', 'annulé','envoyé',
        'reporte', 'pas_de_reponse', 'refusé', 'retourne','Boîte vocale'
    ];

    useEffect(() => {
        checkAdminStatus();
    }, []);

 useEffect(() => {
    if (isAdmin) {
        fetchAllOrders(currentPage + 1);
    }
}, [isAdmin, currentPage, statusFilter, dateFilter, searchID]);
console.log(orders);
useEffect(() => {
    if (!isAdmin) return;

    const interval = setInterval(() => {
        fetchAllOrders(currentPage + 1);
    }, 15000); // every 15s

    return () => clearInterval(interval);
}, [isAdmin, currentPage, statusFilter, dateFilter, searchID]);

    const checkAdminStatus = () => {
        const isAdmin = localStorage.getItem('isAdmin') === '1';
        setIsAdmin(isAdmin);
        // Note: No need to call fetchAllOrders here, the second useEffect will handle it.
    };

   const fetchAllOrders = async (page) => {
    try {
        const token = localStorage.getItem('authToken');
        if (!token) return;

        const params = new URLSearchParams();
        params.append('page', page);
        if (statusFilter) params.append('status', statusFilter);
        if (dateFilter) params.append('date_range', dateFilter);
        if (searchID.trim()) params.append('search', searchID.trim());

        const response = await axios.get(
            `https://rehabwmg.online/api/admin/ordersSans?${params.toString()}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
const data = response.data.data || response.data;
const fetchedOrders = data.data || data;

// Display only visitor orders (SupplierID is null)
const newOrders = fetchedOrders.filter(
    (order) => order.SupplierID === null
);

setOrders((prev) => {
    if (JSON.stringify(prev) !== JSON.stringify(newOrders)) {
        return [...newOrders].sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
    }

    return prev;
});

setTotalPages(data.last_page || 1);


    setOrders(prev => {
    if (JSON.stringify(prev) !== JSON.stringify(newOrders)) {
        // sort newest first
        return [...newOrders].sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
    }
    return prev;
});

        setTotalPages(data.last_page || 1);

    } catch (error) {
        console.error(error);
    }
};
 
    const handleStatusChange = async (orderID, newStatus, paymentStatus) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) {
                return;
            }
            
            const response = await axios.put(
                `https://rehabwmg.online/api/admin/orders/${orderID}/tracking`,
                { CurrentStatus: newStatus },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (response.status === 200) {
                fetchAllOrders(currentPage + 1); // Re-fetch orders after status update
            } else {
                return;
            }
        } catch (error) {
            console.error("Erreur lors de la mise à jour du statut:", error);
            alert(`Erreur lors de la mise à jour du statut: ${error.response?.data?.error || error.message}`);
        }
    };

    const handlePageChange = (selectedPage) => {
        // We use page-1 here because the backend expects 1-based index, but React-Paginate often uses 0-based index.
        // Your code uses a custom pagination, so we'll adjust the logic.
        // Assuming your array map logic means currentPage is 0-based, and we want 1-based index for API.
        const newPage = selectedPage.selected + 1;
        setCurrentPage(newPage - 1); // Store 0-based index
    };
    
    // Custom Pagination handlers (matching your existing logic structure)
    const handlePrevPage = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages - 1) {
            setCurrentPage(currentPage + 1);
        }
    };

const handleDeleteOrder = async (orderID, status) => {
    if (!status) return;

    // Normalizing the status string
    const normalizedStatus = status
        ?.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();

    // Logic to allow deletion only if status is NOT final/undesired terminal state
    const isFinalStatus = [
        'livre', 'annule', 'pas_de_reponse', 'reporte', 'refuse', 'retourne'
    ].includes(normalizedStatus);

    if (isFinalStatus) {
        Swal.fire({
            icon: 'error',
            title: 'Action non autorisée',
            text: "Suppression impossible : La commande est dans un état final.",
            confirmButtonColor: '#6B1615', // Using your brand burgundy color
        });
        return;
    }

    // Modern SweetAlert2 Confirmation
    const result = await Swal.fire({
        title: 'Êtes-vous sûr ?',
        text: `Voulez-vous vraiment supprimer la commande #${orderID} ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Oui, supprimer !',
        cancelButtonText: 'Annuler',
        reverseButtons: true
    });

    if (result.isConfirmed) {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) return;

            // Show loading state while deleting
            Swal.fire({
                title: 'Suppression en cours...',
                didOpen: () => { Swal.showLoading() },
                allowOutsideClick: false
            });

            const response = await axios.delete(`https://rehabwmg.online/api/admin/orders/${orderID}`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Supprimée !',
                    text: "La commande a été supprimée avec succès.",
                    timer: 2000,
                    showConfirmButton: false
                });
                fetchAllOrders(currentPage + 1);
            } else {
                throw new Error("Erreur serveur");
            }
        } catch (error) {
            console.error("Erreur lors de la suppression :", error);
            Swal.fire({
                icon: 'error',
                title: 'Échec',
                text: error.response?.data?.error || "Une erreur s'est produite lors de la suppression.",
            });
        }
    }
};    // Client-side filter for orders retrieved on the current page
  const filteredOrders = orders.filter(order => {
  const matchStatus = statusFilter ? order.Status === statusFilter : true;

 const matchDate = dateFilter
  ? (() => {
      const orderDate = new Date(order.created_at);
      const now = new Date();
      const pastTimestamp = now.getTime() - parseInt(dateFilter, 10) * 24 * 60 * 60 * 1000;
      return orderDate.getTime() >= pastTimestamp && orderDate.getTime() <= now.getTime();
    })()
  : true;
  const searchTerm = searchID.trim();

 const matchSearchID = searchTerm
  ? order.OrderID.toString().includes(searchTerm) ||
    (order.supplier?.id && order.supplier.id.toString().includes(searchTerm)) ||
    (order.supplier?.custom_id && order.supplier.custom_id.toString().includes(searchTerm)) ||
    (order.customer_info.Name && order.customer_info.Name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (order.customer_info.Phone && order.customer_info.Phone.includes(searchTerm))
  : true;


  return matchStatus && matchDate && matchSearchID;
});
    if (!isAdmin) {
        return <p className="text-danger text-center">Unauthorized: You do not have admin access.</p>;
    }
const handleSendToDelivery = async (order) => {
  const orderId = getOrderUniqueId(order);
  
  // Call the helper
  await sendToGoodDelivery(
    order, 
    t, 
    (loadingState) => {
      // Logic for your specific loader
      if(loadingState) setDeliveryLoadingId(orderId);
      else setDeliveryLoadingId(null);
    }
  );
};
const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditingOrder(prev => ({ ...prev, [name]: value }));
};

const updateItemQuantity = (index, newQty) => {
    const newItems = [...editingOrder.items];
    newItems[index].Quantity = parseInt(newQty) || 1;
    setEditingOrder({ ...editingOrder, items: newItems });
};

const removeItem = (index) => {
    const newItems = editingOrder.items.filter((_, i) => i !== index);
    setEditingOrder({ ...editingOrder, items: newItems });
};

const submitEdit = async () => {
    try {
        const token = localStorage.getItem('authToken');
        
        // Show loading state
        Swal.fire({
            title: 'Chargement...',
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false
        });

        await axios.put(`https://rehabwmg.online/api/admin/orders/${editingOrder.OrderID}`, editingOrder, {
            headers: { Authorization: `Bearer ${token}` }
        });

        // Success Toast (Modern Minimalist Style)
        Swal.fire({
            icon: 'success',
            title: 'Modifié avec succès',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
        });

        setIsEditModalOpen(false);
        fetchAllOrders(currentPage + 1);
    } catch (error) {
        console.error(error);
        Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: 'Une erreur est survenue lors de la modification.',
            confirmButtonColor: '#6a9739', // Matches your brand green
        });
    }
};
const hasSupplierOrders = orders.some(order => order.SupplierID !== null);
// 1. Définir une fonction utilitaire pour extraire le nom
const getProductName = (product) => {
  if (!product || !product.Name) return '';

  let nameObj = product.Name;

  // Si Name est reçu sous forme de chaîne JSON (ex: '{"ar":"...", "fr":"..."}')
  if (typeof nameObj === 'string') {
    try {
      nameObj = JSON.parse(nameObj);
    } catch (e) {
      return product.Name; // Si ce n'est pas du JSON, retourner la chaîne brute
    }
  }

  // Sélectionner la langue actuelle, ou 'fr' par défaut, ou la première disponible
  const lang = i18n.language || 'fr';
  return nameObj[lang] || nameObj['fr'] || nameObj['ar'] || '';
};
    return (
        <AnimationRevealPage>
            <LightAdmin />
                              <NotificationBell />

            <div className="d-flex">
                <section className="w-100 p-3">
                    <div className="d-flex flex-wrap align-items-center justify-content-center mb-4 gap-4">

                        <h1 className="text-dark display-5 w-100 text-center mb-3">
                            {t('Tableau_de_bord_commandes')}
                        </h1>

                        <div className="d-flex flex-wrap align-items-center gap-3 justify-content-center">

                            <div className="d-flex flex-column">
                                <label className="form-label fw-bold text-dark mb-1 text-center">
                                    {t('Filtrer_par_statut')}
                                </label>
                                <select
                                    className="form-select border-dark shadow-sm"
                                    style={{ minWidth: '180px', maxWidth: '220px' }}
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                >
                                    <option value="">{t('Tous_les_statuts')}</option>
                                    {/* UPDATED STATUS OPTIONS */}
                                    {ALL_STATUSES.map(status => (
                                        <option key={status} value={status}>
                                            {t(status.replace(/\s/g, '_'))}
                                        </option>
                                    ))}
                                    {/* END UPDATED STATUS OPTIONS */}
                                </select>
                            </div>

                            <div className="d-flex flex-column">
                                <label className="form-label fw-bold text-dark mb-1 text-center">
                                    {t('Filtrer_par_date')}
                                </label>
                                <select
                                    className="form-select border-dark shadow-sm"
                                    style={{ minWidth: '180px', maxWidth: '220px' }}
                                    value={dateFilter}
                                    onChange={(e) => setDateFilter(e.target.value)}
                                >
                                    <option value="">{t('Toutes_les_dates')}</option>
                                    <option value="7">{t('7_derniers_jours')}</option>
                                    <option value="15">{t('15_derniers_jours')}</option>
                                    <option value="30">{t('30_derniers_jours')}</option>
                                </select>
                            </div>

                            <div className="d-flex flex-column">
                                <label className="form-label fw-bold text-dark mb-1 text-center">
                                    {t('Recherche_par_ID')}
                                </label>
                                <input
                                    type="text"
                                    className="form-control border-dark shadow-sm"
                                    style={{ minWidth: '180px', maxWidth: '220px' }}
                                    placeholder={t('Recherche_par_ID_nom_ou_téléphone')}
                                    value={searchID}
                                    onChange={(e) => setSearchID(e.target.value)}
                                />
                            </div>

                            <div className="d-flex align-items-end">
                                <button
                                    className="btn"
                                    onClick={() => {
                                        setStatusFilter('');
                                        setDateFilter('');
                                        setSearchID('');
                                        setCurrentPage(0); // Reset to first page on filter reset
                                    }}
                                    style={{
                                        height: '38px',
                                        backgroundColor: '#6a9739',
                                        color: 'white',
                                        borderRadius: '25px',
                                        padding: '0 20px',
                                        border: 'none',
                                        cursor: 'pointer',
                                        boxShadow: '0 2px 6px rgba(106, 151, 57, 0.6)',
                                        transition: 'background-color 0.3s ease',
                                        marginTop: '30px'
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#4e7662'}
                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = '#6a9739'}
                                >
                                    {t('Reinitialiser_les_filtres')}
                                </button>
                            </div>

                        </div>
                    </div>
                    <hr className="my-4" />

                    {/* Orders Table */}
                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                                <tr>
                                    <th> {t('ID_de_commande')}</th>
                                    <th> {t('Fournisseur')}</th>
                                    <th> {t('Client')}</th>
                                    <th>{t('Type_du_paiement')}</th>
                                    <th> {t('Produits')}</th>
                                    <th> {t('Montant')}</th>
{hasSupplierOrders && <th>{t('Gain')}</th>}                                 
   <th> {t('Notes')}</th>
                                    <th> {t('Created_at')}</th>
                                    <th> {t('statut')}</th>
                                    <th> {t('Actions')}</th>

                                </tr>
                            </thead>
                            <tbody>
                                {filteredOrders.length > 0 ? (
                                    filteredOrders.map((order) => {
                                        const normalizedStatus = order.Status
                                            ?.normalize("NFD")
                                            .replace(/[\u0300-\u036f]/g, "")
                                            .toLowerCase()
                                            .trim();

                                        const isDeletable = !['livre', 'annule', 'pas_de_reponse', 'reporte', 'refuse', 'retourne'].includes(normalizedStatus);


                                        return (
                                            <tr key={order.OrderID}>
                                                <td>{order.OrderID}</td>
                                                <td>
                                                    {order.supplier?.name || t('Commandes_sans_code_promo')}<br />
                                                    <small className="text-muted"> {order.supplier?.custom_id}</small>
                                                </td>
                                                <td>
                                                    {order.customer_info.Name}&nbsp;<br />
                                                    <a href={`tel:${order.customer_info.Phone}`} style={{ color: 'blue', textDecoration: 'underline' }}>
                                                        {order.customer_info.Phone}<br />
                                                    </a>&nbsp;
                                                    {order.customer_info.Address}&nbsp;
                                                    Ville:{order.customer_info.city}
                                                </td>
                                                <td>{order.payment_type}</td>
                                                <td>
                                                   {order.order_items?.map((item, index) => (
  <div key={index} className="product-item-row mb-1">
    {/* Affichage propre du nom du produit */}
    <span className="fw-semibold">
      {getProductName(item.product)}
    </span>
    
    {/* Quantité */}
    <span className="text-muted ms-2">
      (x{item.Quantity})
    </span>
  </div>
))}                                                </td>

                                                <td>{order.payment.Amount} {t("currency")}</td>
{hasSupplierOrders && (
            <td>
              {order.SupplierID ? `${order.gain} ${t('currency')}` : "-"}
            </td>
          )}                                        <td>{order.notes || ''}</td>

<td>
  {new Date(order.created_at).toLocaleString("fr-MA", {
    timeZone: "Africa/Casablanca"
  })}
</td>
                                                <td>
                                                    <select
                                                        value={order.Status}
                                                        onChange={(e) => handleStatusChange(order.OrderID, e.target.value, order.payment.PaymentStatus)}
                                                        className="form-control"
                                                        // Disable for the two final states only
                                                        disabled={['livré', 'annulé'].includes(order.Status)} 
                                                    >
                                                        {/* UPDATED STATUS OPTIONS IN TABLE */}
                                                        {ALL_STATUSES.map(status => (
                                                            <option key={status} value={status}>
                                                                {t(status.replace(/\s/g, '_'))}
                                                            </option>
                                                        ))}
                                                        {/* END UPDATED STATUS OPTIONS IN TABLE */}
                                                    </select>
                                                </td>
<td>
    <div className="d-flex gap-2">
<button 
    className="btn btn-sm btn-primary" 
    onClick={() => {
        // Fix: Use underscores to match your data structure (customer_info / order_items)
        setEditingOrder({
            OrderID: order.OrderID,
            Name: order.customer_info?.Name || '', 
            Phone: order.customer_info?.Phone || '',
            Address: order.customer_info?.Address || '',
            City: order.customer_info?.city || '',
            notes: order.notes || '',
            TotalAmount: order.payment?.Amount || 0,
            items: order.order_items ? order.order_items.map(item => ({ 
                ProductID: item.ProductID,
                Name: item.product?.Name?.[currentLang] || 'Product',
                Quantity: item.Quantity,
Price: item.Price 
            })) : []
        });
        setIsEditModalOpen(true);
    }}
>
    <i className="fas fa-edit"></i>
</button>
        {/* New Delivery Button */}
        <button
            className="btn btn-sm btn-success"
            onClick={() => handleSendToDelivery(order)}
            disabled={deliveryLoadingId === getOrderUniqueId(order)}
            title="Envoyer à GoodDelivery"
        >
            {deliveryLoadingId === getOrderUniqueId(order) ? (
                <i className="fas fa-spinner fa-spin"></i>
            ) : (
                <i className="fas fa-shipping-fast"></i>
            )}
        </button>

        {/* Your existing Delete Button */}
        <button
            className="btn btn-sm"
            style={{ backgroundColor: 'red', color: 'white' }}
            disabled={!isDeletable}
            onClick={() => handleDeleteOrder(order.OrderID, order.Status)}
            title="Supprimer"
        >
            <i className="fas fa-trash"></i>
        </button>
    </div>
</td>

                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="10" className="text-center">
                                            {t('Aucune_commande_trouvée')}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="d-flex justify-content-center">
                        <nav>
                            <ul className="pagination">
                                {/* Corrected pagination logic */}
                                <li className={`page-item ${currentPage === 0 ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={handlePrevPage} disabled={currentPage === 0}>
                                        {t('Previous')}
                                    </button>
                                </li>
                                {[...Array(totalPages)].map((_, index) => (
                                    <li key={index} className={`page-item ${currentPage === index ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => setCurrentPage(index)}>
                                            {index + 1}
                                        </button>
                                    </li>
                                ))}
                                <li className={`page-item ${currentPage === totalPages - 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" onClick={handleNextPage} disabled={currentPage === totalPages - 1}>
                                        {t('Next')}
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>


                    {/* Admin Instructions */}
                    <div className="alert alert-info mt-4"
                        style={{ backgroundColor: '#4e7662' }}
                    >
                        <h5 style={{ color: "white" }}>Instructions pour l'admin :</h5>
                        <ul style={{ color: "white" }}>
                            <li>Une commande ne peut pas être marquée comme "Livré" si le paiement est "not payé".</li>
                            <li>Le bouton "Supprimer" est désactivé si la commande est dans un état final (livré, annulé, refusé, retourné, etc.).</li>
                        </ul>
                    </div>
                </section>
            </div>
            <Footer />
{isEditModalOpen && editingOrder && (
    <div className="custom-modal-overlay">
        <div className="custom-modal-content">
            <h3 className="mb-4 border-bottom pb-2">Modifier Commande #{editingOrder.OrderID}</h3>
            
            <div className="row">
                <div className="col-md-6">
                    <label>Nom Client</label>
                    <input className="form-control" name="Name" value={editingOrder.Name} onChange={handleEditInputChange} />
                </div>
                <div className="col-md-6">
                    <label>Téléphone</label>
                    <input className="form-control" name="Phone" value={editingOrder.Phone} onChange={handleEditInputChange} />
                </div>
                <div className="col-md-6">
                    <label>Adresse</label>
                    <input className="form-control" name="Address" value={editingOrder.Address} onChange={handleEditInputChange} />
                </div>
                <div className="col-md-6">
                    <label>Ville</label>
                    {/* Fixed: Use City (Capitalized) to match your state logic */}
                    <input className="form-control" name="City" value={editingOrder.City} onChange={handleEditInputChange} />
                </div>
            </div>

            <h5 className="mt-4 mb-3">Produits</h5>
            <div className="product-list-container">
                {editingOrder.items && editingOrder.items.length > 0 ? (
                    editingOrder.items.map((item, index) => (
                        <div key={index} className="d-flex gap-3 align-items-center product-item-row">
                            <span className="flex-grow-1 fw-bold">{item.Name}</span>
                            <div className="d-flex align-items-center gap-2">
                                <label className="mb-0 small">Qty:</label>
                                <input 
                                    type="number" 
                                    className="form-control" 
                                    style={{ width: '80px' }}
                                    value={item.Quantity} 
                                    onChange={(e) => updateItemQuantity(index, e.target.value)} 
                                />
                            </div>
                            <button className="btn btn-outline-danger btn-sm" onClick={() => removeItem(index)}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    ))
                ) : (
                    <p className="text-muted italic">Aucun produit dans cette commande.</p>
                )}
            </div>

            <div className="mt-4 row">
                <div className="col-md-6">
                    <label>Total de la commande ({t('currency')})</label>
                    <input 
                        type="number" 
                        className="form-control fw-bold" 
                        style={{ backgroundColor: '#f0fdf4' }} // Light green tint
                        name="TotalAmount" 
                        value={editingOrder.TotalAmount} 
                        onChange={handleEditInputChange} 
                    />
                </div>
            </div>

            <div className="mt-3">
                <label>Notes</label>
                <textarea 
                    className="form-control" 
                    name="notes" 
                    rows="3"
                    placeholder="Ajouter une note..."
                    value={editingOrder.notes} 
                    onChange={handleEditInputChange}
                ></textarea>
            </div>

            <div className="d-flex justify-content-end gap-3 mt-5 pt-3 border-top">
                <button className="btn btn-light px-4" onClick={() => setIsEditModalOpen(false)}>Annuler</button>
                <button className="btn btn-success px-4" onClick={submitEdit}>Enregistrer les modifications</button>
            </div>
        </div>
    </div>
)}        </AnimationRevealPage>
    );
};

export default OrdersSans;